var pagingModule = (function() {

	// privates
	var pagingData = {};

	function initialize(templatePaging, pageSize, labels) {
		pagingData.templatePaging = templatePaging;
		pagingData.pageSize = pageSize;
		pagingData.functionName = labels.loadTransactions;
		pagingData.hyphentext = labels.hyphentext;
		pagingData.resultstext = labels.resultsfoundtext;
		pagingData.resultsfoundtext = labels.resultstext;
		pagingData.gotopagetext = labels.gotopagetext;
		pagingData.startPage = 1;

	}

	function createPagination(totalCount, resultsOnPage, requestedPage, accountNumber) {
		setPagingDataForAccount(totalCount, resultsOnPage, requestedPage, accountNumber);
		return Mustache.render(pagingData.templatePaging, pagingData);
	}

	function setPagingDataForAccount(totalCount, resultsOnPage, requestedPage, accountNumber) {
		var intRegex = /^\d+$/;
		var currentPage = 1;
		if (requestedPage && intRegex.test(requestedPage)) { 
			currentPage = Math.max(requestedPage, 1);
		} 

		if (resultsOnPage < pagingData.pageSize && currentPage == 1) {
			totalCount = resultsOnPage;
		}

		pagingData.functionParams = accountNumber;
		pagingData.accountNumber = accountNumber;
		pagingData.currentPage = currentPage;
		pagingData.previousPage = pagingData.currentPage - 1;
		pagingData.nextPage = pagingData.currentPage + 1;
		pagingData.totalPages = Math.ceil(totalCount / pagingData.pageSize);
		pagingData.firstResultOnPage = ((pagingData.currentPage - 1) * pagingData.pageSize) + 1;
		pagingData.lastResultOnPage = Math.min(totalCount, pagingData.firstResultOnPage + resultsOnPage - 1);
		pagingData.totalResults = totalCount;
		pagingData.showPrevious = (pagingData.totalPages > 1 && pagingData.currentPage > 1);
		pagingData.showNext = (pagingData.totalPages > 1 && pagingData.currentPage < pagingData.totalPages);
		pagingData.showInput = (pagingData.showPrevious || pagingData.showNext);
		pagingData.firstPage = setFirstPageData(pagingData);
		pagingData.lastPage = setLastPageData(pagingData);

		pagingData.truncateAtStart = false;
		pagingData.truncateAtEnd = false;
		
		if(pagingData.totalPages > 7 ) {
		// Check if pages needs to be truncated at beginning
			if(pagingData.currentPage >4) {
				pagingData.truncateAtStart = true;
			} 
			// Check if pages needs to be truncated at End
			if((pagingData.totalPages - pagingData.currentPage)> 3 ) {
					pagingData.truncateAtEnd = true;
			}
			pagingData.pages = updateTruncatedPages(pagingData);
		}else {
			// if pages are less than 8 then it need not be hidden
			pagingData.pages = createPages(pagingData,false);
		}
	}	
	
	function createPages(pagingData ,status) {
		var pageCount = 1;
		var pages = [];
		while (pageCount <= pagingData.totalPages) {
			//Ignoring First and Last page
			if(pageCount == 1 || pageCount == pagingData.totalPages) {
				pageCount++;
				continue;
			}
			var page = {};
			page.pagenumber = pageCount;
			page.active = (pagingData.currentPage == pageCount);
			page.hide = status;
			pages.push(page);
			pageCount++;
		}
		return pages;
	}

	function setFirstPageData(pagingData) {
		var firstPage = {};
		firstPage.pagenumber =1;
		firstPage.active = (pagingData.currentPage==1);
		return firstPage;
	} 
	
	function setLastPageData(pagingData) {
		var lastPage = {};
		lastPage.pagenumber = pagingData.totalPages;
		lastPage.active = (pagingData.currentPage == pagingData.totalPages);
		return lastPage;
	} 
	
	function updateTruncatedPages(pagingData) {
		var pageCount = 1;
		var pages = createPages(pagingData,true);
		var truncateAtboth = pagingData.truncateAtStart && pagingData.truncateAtEnd;
		if(truncateAtboth) {
			var currentPage = pagingData.currentPage;
			
			//(currentpage-2 -(first and last page )) (currentpage+ 2 -(first and last page))
			for (var id= currentPage-4 ; id < currentPage + 1 ; id++) {
				pages[id].hide = false;
			}
			
		}else if(pagingData.truncateAtStart) {
			for (var id= pages.length - 5 ; id < pages.length  ; id++) {
				pages[id].hide = false;
			}
		}else if(pagingData.truncateAtEnd) {
			for (var id= 0 ; id < 5  ; id++) {
				pages[id].hide = false;
			}
		}

		return pages;
	}

	

	return {
		initialize : initialize,
		createPagination : createPagination
	};

})();